import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVert from '@material-ui/icons/MoreVert';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import withRoot from "../../withRoot";

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  menuIconTableCell: {
    width: 100 + "px"
  },
 menuIconContainer: {
    cursor: "pointer",
    padding: 5 + "px"
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.secondary.light,
    }
  },
  detailsTableCell: {
    padding: "0 !important"
  },
  searchField: {
    fontSize: '0.9rem',
    fontWeight: 'normal',
  },
  searchIcon: {
    fontSize: '0.9rem',
  },
  searchAdornment: {
    marginRight: '0px',
  }
});

class UsersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: -1,
      anchorEl: null,
      selectedUser: null,
      searchFieldValues: {
        name: '',
        email: '',
        role: '',
        company: ''
      }
    }
  }

  componentDidMount() {
    // Initialize searchfieldvalues from redux state
    this.setState({
      searchFieldValues: {...this.props.searchFieldValues}
    });
  }

  handleClick = (event) => {
    this.handleMenuClose();
    this.setState({ selectedRow: this.state.selectedUser.id });
    this.props.handleEditClick(this.state.selectedUser);
    this.handleMenuClose();
  }

  handleMenuClick = (event, user) => {
    this.setState({ anchorEl: event.currentTarget, selectedUser: user });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null, selectedUser: null });
  };

  handleUserDelete = (event) => {
    event.stopPropagation();
    this.setState({ selectedRow: this.state.selectedUser.id });
    this.props.handleUserDelete(this.state.selectedUser);
    this.handleMenuClose();
  }

  isSelected = (id) => {
    return this.state.selectedRow === id && this.props.useSelectedRow;
  }

  handleSearchFieldChange = (property) => (event) => {
    this.setState({searchFieldValues: {...this.state.searchFieldValues, [property]: event.target.value}})
    this.props.handleSearchFieldChange({[property]: event.target.value});
  }

  filterUsersData = () => {
    let updatedUsers = this.props.users;

    if(this.state.searchFieldValues.name !== ''){
      updatedUsers = updatedUsers.filter( t => {
        const name = `${t.firstName} ${t.lastName}`
        return name.toLowerCase().search(this.state.searchFieldValues.name.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.email !== ''){
      updatedUsers = updatedUsers.filter( t => {
        return t.email.toLowerCase().search(this.state.searchFieldValues.email.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.role !== ''){
      updatedUsers = updatedUsers.filter( t => {
        const userRole = this.state.searchFieldValues.role;
        return t.role.slice(0, userRole.length).toLowerCase().includes(userRole.toLowerCase());
      })
    }
    if(this.state.searchFieldValues.company !== ''){
      updatedUsers = updatedUsers.filter( t => {
        return t.companyName.toLowerCase().search(this.state.searchFieldValues.company.toLowerCase()) !== -1;
      })
    }

    return updatedUsers;
  }

  render() {
    const { classes, role } = this.props;

    const { anchorEl } = this.state;
    const showUsers = this.filterUsersData();
    return (

      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Name</Grid>
                  <Grid item>
                    <Input
                      id='usersname'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.name}
                      onChange={this.handleSearchFieldChange('name')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Email</Grid>
                  <Grid item>
                    <Input
                      id='usersemail'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.email}
                      onChange={this.handleSearchFieldChange('email')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Role</Grid>
                  <Grid item>
                    <Input
                      id='usersrole'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.role}
                      onChange={this.handleSearchFieldChange('role')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction='column'>
                  <Grid item>Company</Grid>
                  <Grid item>
                    <Input
                      id='userscompany'
                      className={classes.searchField}
                      type='text'
                      value={this.state.searchFieldValues.company}
                      onChange={this.handleSearchFieldChange('company')}
                      startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                      fullWidth={true}
                      inputProps={{size: 4}}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              {role === "admin" && <TableCell></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {showUsers.map(t => {
              const isSelected = this.isSelected(t.id);
              return (
                <TableRow className={classes.row} selected={isSelected} key={t.id}>
                  <TableCell>{t.firstName} {t.lastName}</TableCell>
                  <TableCell>{t.email}</TableCell>
                  <TableCell>{t.role}</TableCell>
                  <TableCell>{t.companyName}</TableCell>
                  {role === "admin" && <TableCell className={classes.menuIconTableCell}>
                    <span onClick={event => this.handleMenuClick(event, t)} className={classes.menuIconContainer}><MoreVert className={classes.icon} /></span>
                  </TableCell>}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {role === "admin" && <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleMenuClose}
        >
        <MenuItem onClick={event => this.handleClick(event)}>Edit</MenuItem>
        <MenuItem onClick={event => this.handleUserDelete(event)}>Delete</MenuItem>
      </Menu>}
      </Paper>
    );
  }

}

UsersTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot(withStyles(styles)(UsersTable));



// WEBPACK FOOTER //
// ./src/components/Tables/UsersTable.js